import { useI18N } from '../../../libraries/i18n/hook'
import JoinPremiumButton from './JoinButton'

const BannerPremium = () => {
  const { t } = useI18N()

  return (
    <div className='md:flex items-end justify-between bg-orange-100 sm:mx-8 p-4 rounded-lg text-start border border-solid border-orange'>
      <div>
        <b>BLOOM PRO</b>
        <p className='mt-2 text-xs max-w-lg'>{t('premium.banner.description')}</p>
      </div>
      <div className='mt-4 md:mt-0'/>
      <JoinPremiumButton />
    </div>
  )
}

export default BannerPremium
